import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import ThemeConsumer from "../ThemeConsumer"

const CustomMenuList = ({ theme, ...props }) => {
  return <MenuList {...props} />
}

CustomMenuList.propTypes = {
  theme: PropTypes.object
}

const MenuList = ThemeConsumer("UISelectMulti")(
  ({ theme, children, ...props }) => {
    const { innerRef } = props
    return (
      <div
        ref={innerRef}
        {...props}
        className={classnames(
          theme.p3,
          theme.container,
          theme.containerMenuList
        )}
      >
        {children}
      </div>
    )
  }
)

export default CustomMenuList



// WEBPACK FOOTER //
// ./src/shared/components/SelectMult/CustomMenuList.js